import { useCallback, useEffect, useRef, useState } from 'react';
import copy from 'copy-to-clipboard';

export default function useCopyFeedback(value) {
  const [copiedValue, setCopiedValue] = useState(null);
  const timer = useRef();
  const active = useRef(true);
  const currentValue = useRef(value);
  currentValue.current = value;
  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);
  useEffect(() => {
    setCopiedValue(null);
    return () => clearTimeout(timer.current);
  }, [value]);
  const confirmCopy = useCallback(
    (succeeded) => {
      if (!active.current || currentValue.current !== value) {
        return false;
      }
      clearTimeout(timer.current);
      setCopiedValue(null);
      if (succeeded) {
        setCopiedValue(value);
        timer.current = setTimeout(() => setCopiedValue(null), 1200);
      }
      return succeeded;
    },
    [value]
  );
  const copyValue = useCallback(() => {
    let succeeded = false;
    try {
      succeeded = copy(String(value));
    } catch {
      // A browser can reject clipboard access before the library returns its boolean result.
    }
    return confirmCopy(succeeded);
  }, [value, confirmCopy]);
  return { copied: copiedValue !== null && copiedValue === value, copyValue, confirmCopy };
}
